// Hideo - script editor: the heading outline on the left (drawn by ScriptToc.vue with the toc store, src/stores/toc.ts). Golden tests:
// tests/editor-markdown.test.ts.
import { noZw } from './html'

/** Text of a heading in the outline (without the editor's zero-width spaces) */
export const tocText = (h: Element): string => noZw(h.textContent).trim()
/** Headings 1–3 of the page, in order, without the empty ones */
export const tocHeadings = (root: ParentNode): HTMLElement[] => [...root.querySelectorAll<HTMLElement>('h1,h2,h3')].filter(h => tocText(h))
